import $ from 'jquery'
import postContentSize from './content_size'

$("#decision_helper_preparation_step_27_practitioner, #decision_helper_preparation_step_27_decision").on("change keyup paste", function(){
  var decision_helper_id = $('#decision_helper_id').val()
  var preparation_step_27_practitioner = $('#decision_helper_preparation_step_27_practitioner').val()
  var preparation_step_27_decision = $('#decision_helper_preparation_step_27_decision').val()
  var fields = {preparation_step_27_practitioner: preparation_step_27_practitioner, preparation_step_27_decision: preparation_step_27_decision}
  postContentSize("preparation_step_27", "/content_size/preparation", { decision_helper_id: decision_helper_id, field_name: "preparation_step_27", fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
      $("#preparation_step_27_error").hide()
    } else {
      $("#preparation_step_27_error").show()
    }
  });
});

$("#decision_helper_preparation_step_36_a").on("change keyup paste", function(){
  defaultPreparationHandler("preparation_step_36_a");
});

$("#decision_helper_preparation_step_40_a_headline").on("change keyup paste", function(){
  defaultPreparationHandler("preparation_step_40_a_headline");
});

$("#decision_helper_preparation_step_40_a_text").on("change keyup paste", function(){
  defaultPreparationHandler("preparation_step_40_a_text");
});

$("#decision_helper_preparation_step_40_a_footer").on("change keyup paste", function(){
  defaultPreparationHandler("preparation_step_40_a_footer");
});

function defaultPreparationHandler(field_name){
  var decision_helper_id = $('#decision_helper_id').val()
  var field_value = $('#decision_helper_'+field_name).val()
  var fields = {}
  fields[field_name] = field_value
  postContentSize(field_name, "/content_size/preparation", { decision_helper_id: decision_helper_id, field_name: field_name, fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
     $("#"+field_name+"_error").hide()
    } else {
      $("#"+field_name+"_error").show()
    }
  });
}